const getErrors = ({ key, countrySettings, citiesSettings }) => {
  const errors = []

  if (key === 'enabledChannelLetterbox') {
    const canEnableD2D = citiesSettings.some(
      city => city.enabledChannelLetterbox === true,
    )
    if (!canEnableD2D) {
      errors.push('cantEnableD2D')
    }
    if (!countrySettings.d2dDistributionCosts) {
      errors.push('D2D Distribution Costs')
    }

    if (!countrySettings.flyerPackD2d) {
      errors.push('D2D Flyer Pack')
    }
  }

  if (key === 'enabledChannelPreciseLocations') {
    const canEnableH2H = citiesSettings.some(
      city => city.enabledChannelPreciseLocations === true,
    )
    if (!canEnableH2H) {
      errors.push('cantEnableH2H')
    }
    if (!countrySettings.h2hDistributionCosts) {
      errors.push('H2H Distribution Costs')
    }

    if (!countrySettings.flyerPackH2h) {
      errors.push('H2H Flyer Pack')
    }
  }

  if (!countrySettings.minimumMissionLimit) {
    errors.push('Minimum Mission Limit')
  }

  if (
    !countrySettings.weeklyMissionLimit &&
    countrySettings.weeklyMissionLimit !== null
  ) {
    errors.push('Weekly Mission Limit')
  }

  if (!countrySettings.baPayout) {
    errors.push('BA Payout')
  }

  const citiesWithoutBaPayout = citiesSettings.reduce((acc, city) => {
    if (city.baPayout === 0) {
      acc.push(city.name)
    }
    return acc
  }, [])
  if (citiesWithoutBaPayout.length) {
    errors.push(`BA Payout on ${citiesWithoutBaPayout.join(', ')}`)
  }

  return errors
}

export { getErrors }
